import { StoreActionType as Type } from '../../types';
import { AuthorizationActionTypes } from '../../actions/common/_authorizationActions';

export interface AuthorizationState {
    navigateUrls: string[];
}

const initialState: AuthorizationState = {
    navigateUrls: [],
};

export const authorizationReducer = (
    state: AuthorizationState = initialState,
    action: AuthorizationActionTypes
): AuthorizationState => {
    const newState = {
        ...state,
        navigateUrls: action.payload,
    };
    switch (action.type) {
        case Type.SET_NAVIGATE_URLS:
            return newState;
        default:
            return state;
    }
};
